import React from "react";
import styled from "styled-components";
import { themeGet } from "styled-system";

const Button = styled.button`
  padding: 1rem 1.5rem;
  color: ${props =>
    props.buttonState === "selected"
      ? "white"
      : props.buttonState === "selected-correct"
      ? "white"
      : props.buttonState === "selected-wrong"
      ? "white"
      : props.buttonState === "not-selected-correct"
      ? "#19CA94"
      : "#4844A3"};
  background: ${props =>
    props.buttonState === "selected"
      ? "#4844A3"
      : props.buttonState === "selected-correct"
      ? "#19CA94"
      : props.buttonState === "selected-wrong"
      ? "#FF4A69"
      : props.buttonState === "not-selected-correct"
      ? "white"
      : "white"};
  border: 2px solid
    ${props =>
      props.buttonState === "selected"
        ? "#4844A3"
        : props.buttonState === "selected-correct"
        ? "#19CA94"
        : props.buttonState === "selected-wrong"
        ? "#FF4A69"
        : props.buttonState === "not-selected-correct"
        ? "#19CA94"
        : "white"};
  border-radius: 2rem;
  font-family: ${themeGet("fonts.TTNormsProBold")};
  box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.04);
  outline: none;
  margin-right: 1rem;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  @media screen and (min-width: 72em) {
    margin-top: 7px;
    font-size: 1rem;
    margin-bottom: 0;
    padding: 1rem 1.5rem;
    margin-left: 1rem;
    margin-right: 0;
  }
  :hover {
    cursor: pointer;
  }
`;

export default ({ children, buttonState, selected, onClick }) => (
  <Button selected={selected} buttonState={buttonState} onClick={onClick}>
    {children}
  </Button>
);
